
export default class Modal {
    constructor(modalContainer) {
        this.modalEl = modalContainer;
    }

    open = () => {
        this.modalEl.classList.add('is-open');

        setTimeout(() => {
            this.modalEl.setAttribute('aria-hidden', false);
        }, 50);

        this.bindEscKey();
    };

    close = () => {
        this.unBindEscKey();

        this.modalEl.setAttribute('aria-hidden', true);

        setTimeout(() => {
            this.modalEl.classList.remove('is-open');
        }, 350);
    };

    bindEscKey = () => window.addEventListener('keydown', this.closeModalFromKey);

    unBindEscKey = () => window.removeEventListener('keydown', this.closeModalFromKey);

    closeModalFromKey = (ev) => {
        if (ev.keyCode === 27) { // esc
            this.close();
        }
    };
}

